import React, { useMemo, useState } from 'react';
import BarChartIcon from '@material-ui/icons/BarChart';
import { useTranslate } from 'react-admin';
import DashboardCard from '../DashboardCard';
import MetabaseIframe from '../MetabaseIframe';
import GranularityToggle from './GranularityToggle';
import PeriodPresetMenu from './PeriodPresetMenu';
import PeriodRangeFilter from './PeriodRangeFilter';
import { useMetabaseIframe } from '../../../hooks/useMetabaseIframe';
import { getPeriodRange, PeriodPreset, PeriodRange } from '../../../utils/dashboard/periodRange';
import { MetabaseGroupByTypeDate } from '../../../utils/metabase';

export const AVATAR_CREATION_HISTORY_QUESTION_ID = 105;

const AvatarCreationHistory: React.FC = () => {
    const translate = useTranslate();

    const [range, setRange] = useState<PeriodRange>(() => getPeriodRange('lastWeek'));
    const [granularity, setGranularity] = useState<MetabaseGroupByTypeDate>('day');

    const params = useMemo(
        () => ({
            groupIds: [],
            groupByTypeDate: granularity,
            // Semántica natural. El hook invierte los límites antes de llamar
            // al bridge, porque la question 105 los nombra al revés.
            creationDateAfter: range.from,
            creationDateBefore: range.to,
        }),
        [granularity, range.from, range.to],
    );

    const { iframeUrl, loading, error } = useMetabaseIframe(AVATAR_CREATION_HISTORY_QUESTION_ID, params);

    const handlePreset = (preset: PeriodPreset) => setRange(getPeriodRange(preset));

    return (
        <DashboardCard
            title={translate('app.dashboard.creationObjet')}
            subtitle={translate('app.dashboard.subtitle')}
            icon={<BarChartIcon />}
            actions={
                <>
                    <PeriodRangeFilter value={range} onChange={setRange} />
                    <GranularityToggle value={granularity} onChange={setGranularity} />
                    <PeriodPresetMenu onSelect={handlePreset} />
                </>
            }
        >

            <MetabaseIframe
                url={iframeUrl}
                loading={loading}
                error={error ? translate('app.dashboard.error') : null}
                title={translate('app.dashboard.creationObjet')}
            />
        </DashboardCard>
    );
};

export default AvatarCreationHistory;
